<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { paymenttermService } from "../../../../services/paymentservice/paymentterm.service";
import { servicehelpers } from "../../../../services/servicehelpers";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Schedule Templates List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      templatesList: {},
      roundingRuleList: {},
      fetchingStats: false,
      title: "Schedule Templates List",

    };
  },
  mounted() {
    
    this.loadingRoundingRuleData();
    this.loadingData();
  },

  methods: {
    
    loadingData: function(param = '?page=0') {
    
      param = `?page=0&clause={"clause":[{"conjuction":"and","payment_terms.is_customized":{"value":0}}]}`;
      this.fetchingStats = false;
      paymenttermService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.templatesList = response;
        });
    },

    loadingRoundingRuleData: function() {
      servicehelpers.getRoundingRuleData()
        .then(response => {
          this.roundingRuleList = response;

        });
    },

    deleted: function(id) {
      paymenttermService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-schedule-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-schedule-add'}" :title="$t('setting.configuration.payment-schedule-template.text')" />
    <List v-bind:dataList="templatesList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ `name: ${$t('setting.configuration.payment-schedule-template.text')}`, `period: ${$t('setting.configuration.payment-schedule-template.period')}`, 
          `rounding_rule: ${$t('setting.configuration.payment-schedule-template.rounding-rule')}`, `method: ${$t('setting.configuration.payment-schedule-template.method')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:filter="{
            search: ['payment_terms.name', 'payment_terms.name_en'],
            dropdown: [{
              title: 'setting.configuration.payment-schedule-template.rounding-rule',
              field: 'payment_terms.rounding_rule_id',
              data: this.roundingRuleList.data,
            }],

          }"
          
    />      
  </Layout>
</template>